<div class="modal-header">
  <h4 class="modal-title">{{ "modales.childDetails.title" | translate }}</h4>
</div>
<div class="modal-body">
  <div class="contentContainer">
    <div class="section">
      <div class="subtitle">
        {{ "modales.childDetails.globalProgress" | translate }}
      </div>
      <div class="content">
        <div class="globalProgressContainer">
          <div class="progressText">
            {{ followUp.global_score }} /
            {{ followUp.global_max_score }}
          </div>
          <div class="progressBarContainer">
            <p-progressBar
              [value]="getGlobalProgressValueFrom(followUp)"
              >
              <ng-template pTemplate="content" let-value>
                <span></span>
              </ng-template>
            </p-progressBar>
          </div>
        </div>
      </div>
    </div>

    <div class="section">
      <div class="subtitle">
        {{ "modales.childDetails.lastValidation" | translate }}
      </div>
      <div class="content">
        @if (
          dates[followUp.user_id] === undefined ||
          dates[followUp.user_id].date === undefined
          ) {
          <p-tag
            [severity]="'danger'"
                    [value]="
                        translationService.instant(
                            'modales.childDetails.nothingValidated'
                        )
                    "
            />
        }
        @if (
          dates[followUp.user_id] !== undefined &&
          dates[followUp.user_id].date !== undefined
          ) {
          <p-tag
                    [severity]="
                        getSeverityForLastValidated(dates[followUp.user_id])
                    "
            [value]="getStringForLastValidated(dates[followUp.user_id])"
            />
        }
      </div>
    </div>

    <div class="section">
      <div class="subtitle">
        {{ "modales.childDetails.details" | translate }}
      </div>
      <div class="content">
        @for (progress of followUp.progresses; track progress; let i = $index) {
          <div
            class="detailsModule"
            >
            <div class="line">
              <div class="moduleName">
                {{ getModuleName(progress.module_id) }}
              </div>
              <div class="progressContainer">
                <p-progressBar
                  [value]="getProgressValueFrom(progress)"
                  >
                  <ng-template pTemplate="content" let-value>
                    <span></span>
                  </ng-template>
                </p-progressBar>
              </div>
            </div>
            @if (i < followUp.progresses.length - 1) {
              <p-divider />
            }
          </div>
        }
      </div>
    </div>
  </div>
</div>
<div class="modal-footer">
  <button (click)="validate()" type="button" class="btn btn-primary">
    {{ "common.buttons.ok" | translate }}
  </button>
</div>
